import * as React from 'react';
import { IArticleElements, IImageListingItem } from '../models/article-elements'


interface IProps {
    content: IArticleElements;
}

export class ArticleContent extends React.Component<IProps, any> {
    render() {
        const { content } = this.props;
        return (
            <div className="article-listing-page-item"> 
                <a href={content.pageLink} className="article-listing-page-item-link">
                <div className="article-listing-page-item-inner">
                        <h3 className="cta-card-body-title">{content.title}</h3>
                        <span className="article-listing-page-item-date">{content.displayDate}</span>
                    <div className="cta-card-body-description"><span dangerouslySetInnerHTML={{ __html: content.description }}></span></div>
                    </div>
                    <div className="article-listing-page-item-inner">
                        {content.imageListingItems && content.imageListingItems.map(x => this.renderImageListingItem(x))}
                        </div>
                </a>
            </div>
        );
    }

    renderImageListingItem = (item: IImageListingItem) => {
        return <div className="roster-detail ">
           
            <img className="roster-detail-image" src={item.imageUrl} />
            <div className="roster-detail-image-ie" style={{ backgroundImage: `url(${item.imageUrl})` }}></div>
                <div className="roster-detail-personal"> 
            <h6>{item.title}</h6>
                    <div><span dangerouslySetInnerHTML={{ __html: item.description }}></span></div>
                    </div>
            
        </div>
    }
}